import React from 'react';
import { TicketSelector } from '../../../../../../surveys/containers/SurveyResponses/EventRegistration/components/EventSurvey/EventSurveyForm/components/TicketSelector';
import { IEventTicket } from '../../../../../../surveys/models/Api';

interface PreviewTicketSelectorProps {
	tickets: IEventTicket[];
	selections: Record<string, number>;
	onSelectionChange: (ticketId: string, quantity: number) => void;
	minQuantities?: Record<string, number>;
}

/**
 * Preview wrapper for TicketSelector component
 * Allows ticket selection changes for preview (to show dynamic ticket holder updates)
 * Individual ticket holder fields remain disabled in TicketHolderFields component
 */
export const PreviewTicketSelector: React.FC<PreviewTicketSelectorProps> = ({
	tickets,
	selections,
	onSelectionChange,
	minQuantities = {},
}) => {
	return (
		<TicketSelector
			tickets={tickets}
			selections={selections}
			onSelectionChange={onSelectionChange}
			minQuantities={minQuantities}
			disabled={false}
		/>
	);
};
